/* eslint-disable react/sort-comp */
/* eslint-disable max-len */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Icon,
  Image as SemanticImage,
  Loader,
} from 'semantic-ui-react';
import { AWSUrl } from '../utils/url';

class LoadImage extends Component {
  static propTypes = {
    appConfig: PropTypes.shape({}),
    autoWidth: PropTypes.bool,
    placeholder: PropTypes.node,
    picture: PropTypes.shape({
      key: PropTypes.string,
    }),
    pictureSize: PropTypes.number,
    src: PropTypes.string,
    centered: PropTypes.bool,
    inline: PropTypes.bool,
    size: PropTypes.string,
    shape: PropTypes.string,
    fluid: PropTypes.bool,
    as: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    onClick: PropTypes.func,
    openNewTab: PropTypes.bool,
    labelNode: PropTypes.node,
    cover: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
    notFoundNode: PropTypes.node,
    loading: PropTypes.bool,
    extension: PropTypes.oneOf([
      'jpg', 'jpeg', 'png', 'gif', 'pdf',
    ]),
    constrain: PropTypes.bool,
    asBackground: PropTypes.bool,
    bucketName: PropTypes.string,
    isVideo: PropTypes.bool,
  }
  static defaultProps = {
    extension: 'jpg',
    constrain: null,
    isVideo: false,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
  })
  constructor(props) {
    super(props);
    this.state = {
      eventAdded: false,
      loading: props.loading || true,
      loaded: false,
      loadFail: false,
      backgroundSize: 'cover',
      imgSrc: '',
    };
    this.image = null;
    this.wrapper = React.createRef();
    this.observer = null;
  }
  componentDidMount() {
    if (!this.image && this.state.loading) {
      if (this.props.picture || this.props.src) {
        this.loadImage();
      }
    } else if (this.image && this.image.complete) {
      this.handleOnLoad();
    }
    // Use IntersectionObserver for viewport detection
    this.observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.checkViewPort();
          }
        });
      },
      { threshold: 0.1 },
    );
    if (this.wrapper.current) {
      this.observer.observe(this.wrapper.current);
    }
  }
  componentWillReceiveProps(nextProps) {
    let loaded = false;
    let loading = false;
    if (!this.state.loadFail) {
      if (nextProps.loading !== undefined) {
        loading = nextProps.loading;
      }
      if (
        (nextProps.picture && this.props.picture) ||
        (nextProps.src && this.props.src)
      ) {
        if ((nextProps.picture && this.props.picture &&
          nextProps.picture.key === this.props.picture.key) ||
        (nextProps.src === this.props.src)) {
          loaded = this.state.loaded;
          loading = !loaded;
        }
        if ((nextProps.picture && this.props.picture &&
          nextProps.picture.key !== this.props.picture.key) ||
        (nextProps.src !== this.props.src)) {
          this.removeEvents();
          this.image = null;
          loading = true;
          loaded = false;
        }
        if ((this.props.picture && this.props.picture.key &&
        this.props.picture.key.substr(this.props.picture.key.length - 4).includes('.pdf')) ||
        (nextProps.picture && nextProps.picture.key &&
        nextProps.picture.key.substr(nextProps.picture.key.length - 4).includes('.pdf'))) {
          loaded = true;
          loading = !loaded;
        }
      }
    }
    this.setState({ loaded, loading }, () => {
      if (!loaded && !this.state.loadFail && (
        (nextProps.picture && nextProps.picture.key) || nextProps.src)) {
        if (!this.image) {
          this.loadImage();
        }
      }
    });
  }
  componentWillUnmount() {
    this.endLoad();
    this.removeEvents();
    if (this.observer && this.wrapper.current) {
      this.observer.unobserve(this.wrapper.current);
      this.observer.disconnect();
    }
  }
  getPictureSize = () => {
    const { pictureSize } = this.props;
    let size = '010';
    if (pictureSize) {
      size = parseInt(pictureSize, 10);
      if (pictureSize < 100) {
        size = '0'.concat(size);
      } else {
        size = '100';
      }
    }
    return size;
  }
  getSize = () => {
    const size = this.getPictureSize();
    switch (size) {
      case '010':
        return 'small';
      case '030':
      default:
        return 'medium';
      case '070':
        return 'large';
      case '100':
        return 'huge';
    }
  }
  loadImage = () => {
    let { loaded, loading } = this.state;
    if (!this.state.eventAdded) {
      if ((this.props.picture && this.props.picture.key &&
        this.props.picture.key.substr(this.props.picture.key.length - 4).includes('.pdf'))) {
        loaded = true;
        loading = !loaded;
      }
      this.setState({ eventAdded: true, loaded, loading }, () => {
        this.addEvents();
        requestAnimationFrame(() => {
          this.checkViewPort();
        });
      });
    }
  }
  checkViewPort = async () => {
    if (this.wrapper && this.wrapper.current && this.wrapper.current.parentNode) {
      const wrapper = this.wrapper.current.parentNode.getBoundingClientRect();
      const seeTop = wrapper.top <= window.innerHeight && wrapper.top > 0;
      const seeBottom = wrapper.bottom <= window.innerHeight && wrapper.bottom > 0;
      const isFullyVisible = wrapper.top >= 0 && wrapper.bottom <= window.innerHeight;
      if (seeTop || seeBottom || isFullyVisible) {
        if (!this.state.loaded && !this.state.loadFail &&
        ((this.props.picture && this.props.picture.key) || this.props.src)) {
          let firstLoadError = false;
          // load from base bucket first
          firstLoadError = await this.setNewImage();
          if (firstLoadError) {
            // load from MP bucket
            firstLoadError = await this.setNewImage(this.props.bucketName);
          }
          this.removeEvents();
        }
      }
    }
  }
  setNewImage = bucketName => new Promise((resolve) => {
    this.image = new Image();
    let url = this.renderImage(bucketName);
    this.image.src = url;
    this.image.onload = () => {
      this.setState({ imgSrc: url });
      this.setOnLoad();
      resolve(false);
    };
    this.image.onerror = () => {
      // for pdf payment picture without '.pdf'
      if (url.endsWith('_100.jpg')) {
        url = url.replace('_100.jpg', '.pdf');
        this.image.src = url;
        this.setState({ imgSrc: url });
        this.setOnLoad();
        resolve(false);
      }
      this.handleOnError();
      resolve(true);
    };
  })
  endLoad() {
    if (this.image) {
      this.image.onload = null;
      this.image.onerror = null;
      this.image = null;
      this.removeEvents();
    }
  }
  addEvents() {
    requestAnimationFrame(() => {
      this.checkViewPort();
    });
    const modals = document.getElementsByClassName('ui page modals dimmer transition visible active');
    if ((this.wrapper && this.wrapper.current) && modals.length > 0 && modals[0].contains(this.wrapper.current)) {
      modals[0].addEventListener('load', this.checkViewPort, false);
      modals[0].addEventListener('resize', this.checkViewPort, false);
      modals[0].addEventListener('scroll', this.checkViewPort, false);
    }
    document.addEventListener('DOMContentLoaded', this.checkViewPort, false);
    window.addEventListener('load', this.checkViewPort, false);
    window.addEventListener('resize', this.checkViewPort, false);
    window.addEventListener('scroll', this.checkViewPort, false);
  }
  removeEvents() {
    if (this.state.eventAdded) {
      this.setState({ eventAdded: false }, () => {
        const modals = document.getElementsByClassName('ui page modals dimmer transition visible active');
        if ((this.wrapper && this.wrapper.current) && modals.length > 0 && modals[0].contains(this.wrapper.current)) {
          modals[0].removeEventListener('load', this.checkViewPort, false);
          modals[0].removeEventListener('resize', this.checkViewPort, false);
          modals[0].removeEventListener('scroll', this.checkViewPort, false);
        }
        document.removeEventListener('DOMContentLoaded', this.checkViewPort, false);
        window.removeEventListener('load', this.checkViewPort, false);
        window.removeEventListener('resize', this.checkViewPort, false);
        window.removeEventListener('scroll', this.checkViewPort, false);
      });
    }
  }
  setOnLoad = () => {
    let backgroundSize = 'cover';
    if (this.props.asBackground && this.wrapper && this.wrapper.current) {
      if (
          this.image.height < this.wrapper.current.clientHeight ||
          this.image.width < this.wrapper.current.clientWidth
        ) {
        backgroundSize = 'contain';
      }
    }
    this.handleOnLoad(backgroundSize);
  }
  handleOnLoad = (backgroundSize = 'cover') => {
    this.setState({
      loaded: true,
      loading: false,
      backgroundSize,
    }, () => {
      this.endLoad();
    });
  }
  handleOnError = () => {
    this.setState({
      loading: false,
      loadFail: true,
    }, () => {
      this.endLoad();
    });
  }
  handleOnClick = (e) => {
    if (this.props.onClick && this.state.loaded) {
      this.props.onClick(e);
    }
  }
  handleNewTab = (e) => {
    if (this.props.openNewTab) {
      e.preventDefault();
      const winObj = window.open(this.renderImage(), '_blank');
      winObj.opener = null;
    }
  }
  renderImage(bucketName = null) {
    const { picture, extension } = this.props;
    if (picture && picture.key) {
      let pictureSize = `${this.getPictureSize()}.${extension}`;
      if (picture.key.substr(picture.key.length - 4).includes('.pdf')) {
        pictureSize = '';
      }
      let fileUrl = `${picture.key}${pictureSize}`;
      if (bucketName) fileUrl = `${picture.key}`;
      return AWSUrl(this.props.appConfig, fileUrl, bucketName);
    }
    return this.props.src || '#';
  }
  renderClassNames() {
    const { cover, autoWidth, constrain, isVideo } = this.props;
    const classNames = ['load-image'];
    if (this.state.loaded) {
      classNames.push('loaded');
    }
    if (constrain) {
      classNames.push('constrain');
    }
    if (autoWidth) {
      classNames.push('auto-width');
    }
    if (cover) {
      let ratio = 'ratio';
      switch (cover) {
        case 'long':
          ratio += '2_1';
          break;
        case 'long vertical':
        case 'vertical long':
          ratio += '1_2';
          break;
        default:
          ratio += '16_9';
      }
      classNames.push(ratio);
    }
    if (isVideo) {
      classNames.push('video');
    }
    return classNames.join(' ');
  }
  renderComponentPdf = () =>
    <div className="icon-wrap">
      <div>
        <div className="round icon">
          <img alt="e-signing" src="/assets/images/icons/tick-white.svg" />
        </div>
      </div>
      <p>Document uploaded</p>
    </div>
  renderStyle = (backgroundSize) => {
    const url = this.renderImage();
    const style = {
      backgroundImage: `url(${url})`,
      backgroundSize,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    };
    return style;
  }
  renderComponentType() {
    const { backgroundSize, imgSrc } = this.state;
    const src = imgSrc || this.renderImage();
    const { picture } = this.props;
    if ((picture && picture.key && picture.key.substr(picture.key.length - 4).includes('.pdf')) ||
    src.substr(src.length - 4).includes('.pdf')) {
      return this.renderComponentPdf();
    }
    if (this.props.asBackground) {
      if (this.props.isVideo) {
        return (
          <div
            style={this.renderStyle(backgroundSize)}
          >
            <Icon
              size="big"
              name="video play"
            />
          </div>
        );
      }
      return (
        <div
          style={this.renderStyle(backgroundSize)}
        />
      );
    }
    if (this.props.isVideo) {
      return (
        <Fragment>
          <SemanticImage
            centered
            fluid={this.props.fluid}
            shape={this.props.shape}
            label={this.props.labelNode}
            src={src}
            onClick={this.handleNewTab}
          />
          <Icon
            size="big"
            name="video play"
          />
        </Fragment>
      );
    }
    return (
      <SemanticImage
        centered
        fluid={this.props.fluid}
        shape={this.props.shape}
        label={this.props.labelNode}
        src={src}
        onClick={this.handleNewTab}
      />
    );
  }
  render() {
    const { t } = this.props;
    const { loaded } = this.state;
    return (
      <SemanticImage
        className={this.renderClassNames()}
        as={this.props.as}
        fluid={this.props.fluid}
        size={!this.props.fluid ? this.props.size || this.getSize() : null}
        centered={this.props.centered}
        inline={this.props.inline}
        onClick={this.handleOnClick}
      >
        <div
          ref={this.wrapper}
        >
          {
            loaded ? (
              this.renderComponentType()
            ) : (
              <SemanticImage
                className="load-image-placeholder"
                centered
                shape={this.props.shape}
              >
                <Loader active={this.state.loading}>
                  {this.props.placeholder || t('Loading')}
                </Loader>
                {
                  !this.props.picture && !this.props.src &&
                  !this.state.loading && !this.state.loadFail ?
                  this.props.notFoundNode || t('Not Found') : null
                }
                {
                  this.state.loadFail ? (
                    <Icon
                      size="large"
                      name="exclamation triangle"
                      style={{ marginRight: 0 }}
                    />
                  ) : null
                }
              </SemanticImage>
            )
          }
        </div>
      </SemanticImage>
    );
  }
}

export default withTranslation()(connect(LoadImage.mapStateToProps)(LoadImage));



// WEBPACK FOOTER //
// ./src/components/LoadImage.jsx